import React from "react";
import "./form.css";
import { Field, reduxForm } from "redux-form";
import {
    renderField,
    renderSelectField,
    renderTextArea,
} from "../../Utils/renderField/renderField";
import swal from "sweetalert2";

const renderInputFile = (props) => {

    const inputRef = React.useRef(null);

    const {
        input,
        max,
        title,
        helpfulTip,
        meta: { touched, error },
    } = props;

    React.useEffect(() => {
        if (!input.value) {
            inputRef.current.value = '';
        }
    }, [input.value]);

    const invalid = touched && error;

    const onChange = (e) => {
        if (max && e.target.files.length > max) {
            swal.fire({
                type: "error",
                title: "ERROR!",
                text: "File limit exceeded"
            });
            inputRef.current.value = '';
            input.onChange([]);
        } else {
            input.onChange(e.target.files);
        }
    }

    return (
        <div className="mb-4">
            <label
                htmlFor={input.name}
                className="d-block font-weight-bold mb-1"
            >
                {title} 
                {invalid && (
                    <small className="text-primary"> ({error}) </small>
                )}
            </label>
            <i className="text-secondary mb-2" style={{ fontSize: "0.95rem" }}>
                {helpfulTip}
            </i>
            <div className="d-flex flex-column">
                <input
                    ref={inputRef}
                    id={props.id}
                    name={input.name}
                    onChange={onChange}
                    type="file"
                    accept="image/*"
                    className="primary-input"
                    multiple
                />
            </div>
            <small className="text-secondary">Maximum {max} file{max != 1 ? 's' : ''}</small>
        </div>
    )
}


const Form = (props) => {
    const { handleSubmit, formValues } = props;
    const other_department = formValues && formValues.department && formValues.department == 'other';

    return (
        <form onSubmit={handleSubmit} className="odoo-form w-100 d-flex justify-content-center">
            <div className="col-12 col-md-10 col-xl-8 mb-5">
                <div className="mb-4">
                    <h2>
                        <strong>Feature Request Form</strong>
                    </h2>
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="summary"
                        className="d-block font-weight-bold mb-1"
                    >
                        What happened?
                    </label>
                    <i className="text-secondary mb-2" style={{ fontSize: "0.95rem" }}>
                        A brief description of what went wrong
                    </i>
                    <Field
                        name="summary"
                        component={renderTextArea}
                        className=""
                        rows={4}
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="description"
                        className="d-block font-weight-bold mb-1"
                    >
                        How did it happen?
                    </label>
                    <i className="text-secondary mb-2" style={{ fontSize: "0.95rem" }}>
                        What were you doing when this occurred?
                    </i>
                    <Field
                        name="description"
                        component={renderTextArea}
                        className=""
                        rows={4}
                    />
                </div>

                <div className="d-flex flex-wrap">
                    <div className="col-12 col-md-6 px-0 pr-md-2 pl-md-0 mb-4">
                        <label
                            htmlFor="department"
                            className="d-block font-weight-bold mb-1"
                        >
                            Department/Module
                        </label>
                        <Field
                            name="department"
                            component={renderSelectField}
                            isFormControlActive={false}
                            options={[
                                { value: "Sales", label: "Sales" },
                                { value: "Contacts", label: "Contacts" },
                                { value: "Fleet", label: "Fleet" },
                                { value: "other", label: "Other (please specify)" },
                            ]}
                        />
                    </div>

                    {other_department ? (
                        <div className="col-12 col-md-6 px-0 pl-md-2 pr-md-0 mb-4">
                            <label
                                htmlFor="other_department"
                                className="d-block font-weight-bold mb-1"
                            >
                                Other Departament
                            </label>
                            <Field
                                name="other_department"
                                component={renderField}
                                className="form-control"
                                maxLength={50}
                            />
                        </div>
                    ) : ''}

                    <div className={`col-12 col-md-6 px-0 mb-4 ${other_department ? 'pl-md-0 pr-md-2' : 'pl-md-2 pr-md-0'}`}>
                        <label
                            htmlFor="priority"
                            className="d-block font-weight-bold mb-1"
                        >
                            Priority
                        </label>
                        <Field
                            name="priority"
                            component={renderSelectField}
                            isFormControlActive={false}
                            options={[
                                { value: "critical", label: "Critical (Completely d-blocks work)" },
                                { value: "high", label: "High (Major functionality affected)" },
                                { value: "medium", label: "Medium (Limited functionality affected)" },
                                { value: "low", label: "Low (Minor inconvenience)" },
                            ]}
                        />
                    </div>
                </div>
               
                <Field 
                    name="screenshots"
                    id="screenshots"
                    component={renderInputFile}
                    max={2}
                    helpfulTip="Screenshots help us see exactly what you're seeing"
                    title="Screenshots"
                />

                <Field 
                    name="additional_files"
                    id="additional_files"
                    component={renderInputFile}
                    max={1}
                    helpfulTip="Reports, error logs, or other relevant files"
                    title="Additional Files"
                />

                <button
                    type="submit"
                    className="w-100 btn btn-primary text-white font-weight-bold py-3 px-4 rounded-md"
                >
                    Submit Issue
                </button>
            </div>
        </form>
    );
};

const ErpIssueForm = reduxForm({
    form: "erp_issue",
    validate: (data) => {
        const errors = {};
        if (!data.summary) errors.summary = "Required Field";
        if (!data.description) errors.description = "Required Field";
        if (!data.department) errors.department = "Required Field";
        if (!data.other_department) errors.other_department = "Required Field";
        if (!data.priority) errors.priority = "Required Field";
        return errors;
    },
})(Form);

export default ErpIssueForm;
